import React,{useContext} from 'react';
import styled from 'styled-components';
import {MeetingContext} from '../Context/ChatContext'; 

const ChatRoom = styled.div`
    width: 100%;
    background: #222;
    height: calc(60% - 40px);
    overflow: auto;
    padding: 10px 20px;
    color: #fff;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    
    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 10px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }
`;

const SenderChatItemContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 53px;
`;

const ReceiverChatItemContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    position: relative;
    margin-bottom: 53px;
`;

const AvatarIcon = styled.div`
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 50%;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: ${(props) => props.theme.font.weight.bold};
`;

const SenderChatBubble = styled.div`
    background: #fff;
    width: 200px;
    border-radius: 5px;
    color: #000;
    margin-left: 25px;
    padding: 10px 20px;
    position: absolute;
    left: ${props => !props.right ? '50px' : 'auto'};
    right: ${props => props.right ? '73px' : 'auto'};
    top: 50%;
`;

const RightArrow = styled.div`
    position: absolute;
    width: 0px;
    height: 0px;
    top: 0;
    right: -11px;
    border-left: 14px solid rgb(255 255 255);
    border-bottom: 14px solid transparent;
`;

const LeftArrow = styled.div`
    position: absolute;
    width: 0px;
    height: 0px;
    top: 0;
    left: -11px;
    border-right: 14px solid rgb(255, 255, 255);
    border-bottom: 14px solid transparent;
`;

const ChatRoomLabel = styled.div`
    background-color: ${props => props.theme.backgroundColors.default};
    color: #fff;
    width: 100%;
    padding: 0px 20px;
    height: 40px;
    display: flex;
    align-items: center;
`;

const ChatRoomComponent = ({localUserId}) => {
    const MeetingInfo = useContext(MeetingContext);
    console.log("Meeting Context",MeetingInfo,localUserId);
    return (
        <>
        <ChatRoomLabel>
            <span>ভিডিও রুমের সকল বার্তা সূমহ</span>
        </ChatRoomLabel>
        <ChatRoom>
            {
                MeetingInfo?.messages?.map((message,index) => {
                    if(message.user_id === localUserId) {
                        return (
                            <SenderChatItemContainer key={index}>
                                <AvatarIcon>
                                    <span>I</span>
                                </AvatarIcon>
                                <SenderChatBubble>
                                    <LeftArrow></LeftArrow>
                                    {message.data}
                                </SenderChatBubble>
                            </SenderChatItemContainer>
                        )
                    }else{
                        return (
                            <ReceiverChatItemContainer key={index}>
                                <AvatarIcon>
                                    <span>K</span>
                                </AvatarIcon>
                                <SenderChatBubble right>
                                    <RightArrow></RightArrow>
                                    {message.data}
                                </SenderChatBubble>
                            </ReceiverChatItemContainer>
                        )
                    }
                })
            }
        </ChatRoom>
        </>
    )
}

export default ChatRoomComponent;